import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  ManageTerminalsRootParamList,
  TerminalFormParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { TerminalFormScreen } from "./TerminalFormScreen";
import React from "react";
import { Terminal } from "@towersystems/roam-common/lib/generated-types";
import { useLazyQuery } from "@apollo/client";
import { QUERY_TERMINAL } from "../../common";
import { TerminalForm } from "../../components/TerminalForm";
import { SelectPaymentMethodIdsScreen } from "./SelectPaymentMethodIdsScreen";

const Stack = createStackHeaderNavigator<TerminalFormParamList>();

export type EditTerminalScreenProps = NativeStackScreenProps<
  ManageTerminalsRootParamList,
  "EditTerminalScreen"
>;

export const EditTerminalScreen = ({
  navigation,
  route,
}: EditTerminalScreenProps) => {
  const [terminal, setTerminal] = React.useState<Terminal | undefined>(
    undefined
  );

  const { terminalId } = route.params;

  const [q] = useLazyQuery<{
    terminal: Terminal;
  }>(QUERY_TERMINAL);

  React.useEffect(() => {
    if (terminalId) {
      q({
        variables: { id: terminalId },
      })
        .then((result) => {
          if (result.data?.terminal) {
            setTerminal(result.data.terminal);
          } else {
            navigation.goBack();
          }
        })
        .catch(() => {
          navigation.goBack();
        });
    } else {
      navigation.goBack();
    }
  }, [terminalId]);

  if (!terminal) {
    return null; // or a loading indicator
  }

  return (
    <TerminalForm
      defaultFormValues={{
        id: terminal.id,
        name: terminal.name,
        enabled: terminal.enabled,
        invoiceSequence: terminal.invoiceSequence ?? "1",
        salePrefix: terminal.salePrefix ?? "",
        saleSufix: terminal.saleSufix ?? "",
        paymentMethodIds: terminal.paymentMethodIds ?? [],
      }}
    >
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Back" />,
          title: "",
          headerStyle: {
            backgroundColor: "transparent",
          },
          headerBackgroundContainerStyle: {
            backgroundColor: "transparent",
          },
        }}
      >
        <Stack.Group>
          <Stack.Screen
            name="TerminalFormScreen"
            component={TerminalFormScreen}
          />
        </Stack.Group>
        <Stack.Group
          screenOptions={{
            presentation: "modal",
            headerLeft: () => <ModalCloseButton type="Close" />,
          }}
        >
          <Stack.Screen
            name="SelectPaymentMethodIdsScreen"
            component={SelectPaymentMethodIdsScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </TerminalForm>
  );
};
